(function () {
  try {
    history.scrollRestoration = 'auto';
  } catch (e) {}

  function storageKey() {
    return 'scroll-pos:' + location.pathname + location.search;
  }

  function saveScroll() {
    try {
      sessionStorage.setItem(storageKey(), String(window.scrollY));
    } catch (e) {}
  }

  function restoreScroll() {
    var saved;
    try {
      saved = sessionStorage.getItem(storageKey());
    } catch (e) {
      saved = null;
    }
    if (saved === null) return;

    var y = parseInt(saved, 10);
    if (isNaN(y)) return;

    var attempts = 0;
    var maxAttempts = 30;

    var interval = setInterval(function () {
      window.scrollTo(0, y);
      attempts++;

      // Stop once we've actually landed on the target (within a small
      // tolerance) or we've retried enough times. Re-applying on a loop
      // (rather than a couple of fixed one-off delays) copes with mobile
      // connections where product images keep shifting the page's height
      // for an unpredictable amount of time after the page "loads".
      if (Math.abs(window.scrollY - y) < 2 || attempts >= maxAttempts) {
        clearInterval(interval);
        try {
          sessionStorage.removeItem(storageKey());
        } catch (e) {}
      }
    }, 150);
  }

  // pagehide is the primary save signal, but some mobile browsers / in-app
  // webviews don't fire it reliably on every navigation, so scroll position
  // is also saved continuously (throttled) and on visibility changes as a
  // backup.
  var saveThrottleTimer = null;
  function saveScrollThrottled() {
    if (saveThrottleTimer) return;
    saveThrottleTimer = setTimeout(function () {
      saveThrottleTimer = null;
      saveScroll();
    }, 200);
  }

  window.addEventListener('pagehide', saveScroll);
  window.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') saveScroll();
  });
  window.addEventListener('scroll', saveScrollThrottled, { passive: true });

  // Start restoring as early as possible (DOMContentLoaded, not load) so
  // the correction loop is already running while images are still coming
  // in, rather than waiting for everything to finish first.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScroll);
  } else {
    restoreScroll();
  }
})();
